import Link from "next/link";
import { BlockText, Heading } from "@nju/ui";

export function PrivacyPolicy() {
  return (
    <>
      <Heading font="ttfirs" tone="neutral" variant="h3" weight="bold">
        Polityka prywatności usług nju światłowód i nju komórkowy, nju
        subskrypcja - Aplikacja i strona nju.pl
      </Heading>
      <BlockText className="mt-8">
        Dokument obowiązuje od 15 stycznia 2025 roku do odwołania.
      </BlockText>
      <BlockText className="mt-8">
        Jesteśmy administratorem Twoich danych osobowych. To oznacza, że
        odpowiadamy za ich wykorzystanie w sposób bezpieczny, zgodny z umową
        oraz obowiązującymi przepisami.
      </BlockText>
      <BlockText className="mt-5">Jeśli w tej informacji, piszemy:</BlockText>
      <div className="prose">
        <ul>
          <li>
            o Tobie – mamy na myśli osobę, która korzysta lub chce skorzystać z
            usługi nju, z Aplikacji lub ze strony,
          </li>
          <li>
            o nas – mamy na myśli Orange Polska S.A. (nasze pełne dane
            znajdziesz na końcu dokumentu),
          </li>
          <li>
            o Aplikacji – mamy na myśli Aplikację mobilną, za pomocą której
            można m.in. uzyskać informacje dotyczące Usługi, w tym rozliczenia
            płatności. Za jej pomocą można zawrzeć Umowę oraz zlecać realizację
            dyspozycji w trakcie trwania Umowy, w tym regulować płatności,
          </li>
          <li>o stronie – mamy na myśli stronę internetową nju.pl,</li>
          <li>
            o Serwisie – mamy na myśli łącznie Aplikację oraz stronę internetową
            nju.pl,
          </li>
          <li>
            o Urządzeniu – mamy na myśli urządzenie, za pomocą którego łączysz
            się z Serwisem, takie jak komputer PC, tablet czy telefon
          </li>
        </ul>
      </div>
      <BlockText className="mt-5">
        Poniżej opisujemy, jak przetwarzamy Twoje dane osobowe i chronimy Twoją
        prywatność, kiedy korzystasz z Serwisu.
      </BlockText>
      <BlockText className="mt-5" weight="bold">
        Twoje dane osobowe
      </BlockText>
      <BlockText>
        Jeśli korzystasz z Serwisu, otrzymujemy Twoje dane osobowe i stajemy się
        ich administratorem.
      </BlockText>
      <BlockText className="mt-5" weight="bold">
        1. W jakim celu i na jakiej podstawie wykorzystujemy dane osobowe?
      </BlockText>
      <BlockText>
        Twoje dane osobowe uzyskane przy rejestracji w Aplikacji lub na stronie
        nju.pl oraz w trakcie korzystania z usług dostępnych przez Aplikację i
        na stronie nju.pl wykorzystujemy w następujących celach:
      </BlockText>
      <div className="prose">
        <ol type="a">
          <li>
            zawarcia i wykonania łączących nas umów (w tym o korzystanie ze
            świadczonych przez nas usług elektronicznych lub
            telekomunikacyjnych), np. do zapewnienia poprawnej jakości usług –
            przez czas trwania każdej z umów (podstawa prawna: art. 6 ust. 1 b)
            Rozporządzenia 679/2016 „RODO”, podstawę tę będziemy nazywać w
            skrócie „wykonaniem umowy”);
          </li>
          <li>
            wykonania ciążących na nas obowiązków prawnych, przez czas ich
            wykonania obowiązków, np. dokonania rejestracji abonentów i
            określony przepisami czas przechowywania danych (podstawa prawna:
            art. 6 ust. 1 c) RODO; podstawę tę będziemy nazywać „obowiązkiem
            prawnym”);
          </li>
          <li>
            wykazania naszej zgodności z przepisami - przez czas, w którym
            możemy ponieść konsekwencje prawne niewykonania obowiązku, np.
            otrzymać karę finansową od urzędów państwowych (podstawa prawna:
            art. 6 ust. 1 f) RODO; podstawę tę będziemy nazywać „naszym prawnie
            uzasadnionym interesem”);
          </li>
          <li>
            wykrywania nadużyć i zapobiegania im – przez czas trwania umowy
            (podstawa prawna: wykonanie umowy), przez okres przedawnienia
            roszczeń i czas trwania ewentualnych postępowań (podstawa prawna:
            nasz prawnie uzasadniony interes);
          </li>
          <li>
            ustalenia, obrony i dochodzenia roszczeń, co obejmuje m.in. sprzedaż
            naszych wierzytelności z umowy innemu podmiotowi – przez okres, po
            którym przedawnią się roszczenia wynikające z umowy (podstawa
            prawna: nasz prawnie uzasadniony interes);
          </li>
          <li>
            marketingu bezpośredniego – przez czas trwania umów (podstawa
            prawna: nasz prawnie uzasadniony interes);
          </li>
          <li>
            tworzenia zestawień, analiz i statystyk na nasze potrzeby
            wewnętrzne: obejmuje to w szczególności raportowanie, badania
            marketingowe, planowanie rozwoju usług lub sieci, prace rozwojowe w
            systemach informatycznych, tworzenie modeli statystycznych – przez
            czas trwania umowy, a następnie nie dłużej niż przez okres
            przedawnienia roszczeń (podstawa prawna: nasz prawnie uzasadniony
            interes);
          </li>
          <li>
            wsparcia obsługi, w tym poprzez informowanie o awariach,
            dostosowanie obsługi w oparciu m.in. o dane o ofercie, z której
            korzystasz, czy o dotychczas złożonych reklamacjach – przez czas
            trwania umowy (podstawa prawna: nasz prawnie uzasadniony interes).
          </li>
        </ol>
      </div>
      <BlockText className="mt-3">
        We wskazanych wyżej celach (oprócz celu „wykonania umowy” oraz
        „wykonania obowiązków prawnych”) będziemy dokonywać profilowania, czyli
        zautomatyzowanej analizy Twoich danych i opracowania przewidywań na
        temat preferencji lub przyszłych zachowań (np. w przypadku profilowania
        marketingowego możemy dopasowywać komunikaty reklamowe do Twoich
        potrzeb, wykorzystując dostępne nam informacje o Waszym zachowaniu i
        preferencjach).
      </BlockText>
      <BlockText className="mt-5">
        Jeśli wyrazisz inną zgodę na wykorzystywanie swoich danych, treść tej
        zgody będzie określać, w jakim celu będziemy przetwarzać te dane. Dane o
        tym, że logujesz się w Serwisie, możemy wykorzystać, aby umożliwić Ci
        korzystanie z dodatkowych usług dostępnych w Serwisie, w tym
        świadczonych przez inne podmioty.
      </BlockText>
      <BlockText className="mt-5" weight="bold">
        2. Które dane musisz nam podać, żeby skorzystać z usług
      </BlockText>
      <div className="prose">
        <ol type="a">
          <li>
            Aby zarejestrować Cię w naszej Aplikacji lub na stronie nju.pl,
            musimy poznać Twój adres e-mail. Możesz podać go nam w formularzu
            lub poprzez serwisy społecznościowe, przez które się zalogujesz. Nie
            masz obowiązku prawnego, żeby podać nam swój adres e-mail – jeśli
            jednak go nie podasz, nie możesz założyć konta klienta. Na ten adres
            będziemy przekazywać Ci informacje o zmianach i aktualizacjach
            naszej Aplikacji oraz o zdarzeniach powodujących jej niedostępność
            (prace planowe, awarie);
          </li>
          <li>
            Żeby skorzystać z naszych usług telekomunikacyjnych, musisz się
            wcześniej zarejestrować (czyli podać nam imię i nazwisko, numer
            PESEL lub serię i numer dokumentu, który potwierdza Twoją
            tożsamość). Warunek ten nie wynika z naszej decyzji, ale z przepisów
            prawa. Jeśli nie zarejestrujesz się, nie będziemy mogli wykonywać
            usług telekomunikacyjnych, które określamy w Twoim regulaminie;
            <br />
            Możesz zarejestrować się:
            <ul>
              <li>
                poprzez zdjęcie dokumentu w Aplikacji
                <br />W tym procesie podczas rejestracji wyślesz nam swoje
                zdjęcie („selfie”) oraz zdjęcie Twojego dokumentu tożsamości.
                Informacje o Twoim imieniu i nazwisku, numerze PESEL lub serii i
                numerze dokumentu tożsamości wykorzystamy, aby zarejestrować Cię
                jako naszego abonenta. Twoje zdjęcie z Aplikacji porównamy ze
                zdjęciem z dokumentu tożsamości, aby potwierdzić Twoją
                tożsamość. Po tym kroku nie przechowujemy już dłużej Twojego
                zdjęcia i pozostałych danych. Abyśmy mogli użyć danych z Twojego
                dokumentu tożsamości i zdjęcia „selfie”, w tym danych
                biometrycznych (które uzyskamy nas z Twojego zdjęcia z dokumentu
                tożsamości oraz ze zdjęcia „selfie”), żeby potwierdzić Twoją
                tożsamość, musisz nam na to dać swoją zgodę w Aplikacji.
              </li>
              <li>
                poprzez mojeID
                <br />
                Wystarczy, ze zalogujesz się do swojego banku i zgodzisz się,
                żeby przekazał nam Twoje wskazane dane. Sprawdzamy wyłącznie
                Twoje imię, nazwisko oraz PESEL.
              </li>
            </ul>
            Możemy też umożliwić inne sposoby rejestracji (np. poprzez naszego
            montera).
          </li>
          <li>
            Jeśli podasz w Aplikacji lub na stronie internetowej numer karty
            płatniczej, dane te trafią w bezpieczny sposób bezpośrednio do
            podmiotu, który obsługuje płatność. Podmiot ten działa jako krajowa
            lub zagraniczna instytucja płatnicza, na podstawie uzyskanych
            zezwoleń (będziemy go dalej nazywać „Instytucją płatniczą”). My
            uzyskamy od Instytucji płatniczej tylko informacje:
            <ul>
              <li>o kilku cyfrach z numeru Twojej karty,</li>
              <li>o dacie jej ważności,</li>
              <li>o tym, czy udało się ją skutecznie obciążyć.</li>
            </ul>
            Wykorzystamy je po to, by:
            <ul>
              <li>
                świadczyć Ci nasze usługi zgodnie z regulaminem – przez czas
                trwania umowy,
              </li>
              <li>
                bronić się przed roszczeniami lub dochodzenia roszczeń – do
                czasu ich przedawnienia.
              </li>
            </ul>
          </li>
          <li>
            Gdy korzystasz Aplikacji lub strony nju.pl, możesz zamówić dodatkowe
            usługi lub towary albo skorzystać z funkcjonalności, które nie były
            dotąd objęte umową z nami. W takiej sytuacji możemy wykorzystać
            Twoje dane inaczej niż opisujemy w tej Polityce prywatności.
            Brakujące informacje przekażemy Ci, o ile to możliwe, zanim uzyskamy
            dodatkowe dane lub zanim użyjemy ich w nowym celu. W pozostałym
            zakresie informacje z tej Polityki prywatności pozostaną aktualne.
          </li>
        </ol>
      </div>
      <BlockText className="mt-5" weight="bold">
        3. Komu przekazujemy Twoje dane?
      </BlockText>
      <BlockText>
        Twoje dane przekazujemy różnym kategoriom podmiotów:
      </BlockText>
      <div className="prose">
        <ul>
          <li>
            tym, które przetwarzają dane w naszym imieniu i pomagają nam
            wykonywać nasze zadania,
          </li>
          <li>
            tym, które są osobnymi administratorami i przetwarzają dane we
            własnym imieniu.
          </li>
        </ul>
      </div>
      <BlockText>Odbiorcami Twoich danych mogą być zatem:</BlockText>
      <div className="prose">
        <ol type="a">
          <li>
            nasze agencje reklamowe i inne podmioty pośredniczące w sprzedaży
            naszych usług lub organizacji akcji marketingowych;
          </li>
          <li>
            podmioty obsługujące nasze systemy teleinformatyczne lub
            udostępniające nam narzędzia teleinformatyczne;
          </li>
          <li>
            podwykonawcy wspierający nas np. w wykonywaniu usług
            telekomunikacyjnych lub innych przez Twoich zamówionych, obsłudze
            korespondencji czy w procesie obsługi klientów;
          </li>
          <li>
            podmioty obsługujące i utrzymujące naszą sieć telekomunikacyjną;
          </li>
          <li>
            podmioty świadczące nam usługi doradcze, konsultacyjne, audytowe,
            pomoc prawną, podatkową, rachunkową, agencjom badawczym działającym
            na nasze zlecenie;
          </li>
          <li>instytucje płatnicze obsługujące płatności w Aplikacji;</li>
          <li>dostawcy towarów i usług dostępnych w Aplikacji;</li>
          <li>podmioty prowadzące działalność pocztową lub kurierską;</li>
          <li>
            jeśli przenosisz numer do naszej sieci – Prezes UKE, w związku z
            działaniem systemu, który umożliwia operatorom rozpoznawanie, w
            której sieci działa dany numer telefonu;
          </li>
          <li>
            jeśli otrzymamy od Ciebie zgodę, aby umieścić Twoje dane w spisie
            abonentów - inni przedsiębiorcy telekomunikacyjni, którzy mają
            siedzibę w krajach Europejskiego Obszaru Gospodarczego (EOG), po to,
            aby umieścili Twoje dane w spisie abonentów i korzystali z nich w
            usłudze informacji o numerach telefonicznych.
          </li>
        </ol>
      </div>
      <BlockText className="mt-5">
        Jeśli korzystasz z naszych usług telekomunikacyjnych, przekazujemy
        standardowe informacje techniczne (np. o Twoim numerze telefonu, z
        którego dzwonisz, lub o zakończeniu sieci, z którego łączysz się z
        internetem, Twoje adresy sieciowe i identyfikatory Twojego urządzenia)
        do innych operatorów telekomunikacyjnych lub bezpośrednio do podmiotów,
        z którymi się łączysz, aby wykonać prawidłowo naszą usługę.
      </BlockText>
      <BlockText className="mt-5" weight="bold">
        4. Czy Twoje dane trafią poza Europejski Obszar Gospodarczy (EOG)?
      </BlockText>
      <BlockText>
        Twoje dane mogą być przekazywane poza EOG w sposób przewidziany prawem:
      </BlockText>
      <div className="prose">
        <ol type="a">
          <li>
            na podstawie decyzji Komisji Europejskiej stwierdzającej odpowiedni
            stopień ochrony np. w państwie trzecim, do którego przekazujemy
            dane, lub
          </li>
          <li>
            pod warunkiem zapewnienia odpowiednich zabezpieczeń takich jak:
            <ul>
              <li>wiążące reguły korporacyjne (określone w art. 47 RODO),</li>
              <li>
                standardowe klauzule ochrony danych przyjęte przez Komisję
                Europejską lub właściwy organ nadzorczy w zakresie danych
                osobowych (art. 46 ust. 2 pkt. c lub d RODO),
              </li>
              <li>
                zatwierdzony kodeks dobrych praktyk (art. 46 ust. 2 pkt. e
                RODO),
              </li>
              <li>
                zatwierdzony mechanizm certyfikacji (art. 46 ust. 2 pkt. f
                RODO),
              </li>
              <li>
                klauzule umowne zaakceptowane przez organ nadzorczy (art. 46
                ust. 3 RODO),
              </li>
            </ul>
            a także w przypadkach niezbędnych ze względu na prawnie uzasadnione
            interesy administratora (pod warunkiem spełnienia wymogów z art. 49
            ust. 1 akapit drugi RODO).
          </li>
        </ol>
        Kopię tych zabezpieczeń możesz otrzymać na życzenie.
      </div>
      <BlockText className="mt-5" weight="bold">
        5. Czy podejmujemy automatyczne decyzje
      </BlockText>
      <BlockText>
        Możemy podejmować w pełni automatyczne decyzje, którą mają dla Ciebie
        istotny skutek, aby wykrywać nadużycia przy korzystaniu z usług i
        reagować na nie. W taki sposób możemy uznać określony nietypowy ruch
        telekomunikacyjny za niezgodny z regulaminem i stanowiący tzw. nadużycie
        telekomunikacyjne. W konsekwencji ograniczamy taki ruch lub blokujemy
        numer lub zakończenie sieci, którego go wywołało. Możesz zakwestionować
        taką decyzję i wtedy sprawę rozpatrzy nasz pracownik. Do podjęcia
        automatycznej decyzji wykorzystujemy informacje:
      </BlockText>
      <div className="prose">
        <ul>
          <li>
            o połączeniach telekomunikacyjnych w naszej sieci (w tym o typowych
            i nietypowych wzorach ruchu w sieci),
          </li>
          <li>o przypadkach nadużyć, które dotychczas zaobserwowaliśmy.</li>
        </ul>
      </div>
      <BlockText className="mt-5" weight="bold">
        6. Jak korzystamy z danych transmisyjnych i danych o lokalizacji
      </BlockText>
      <BlockText>
        Jeśli korzystasz z naszych usług telekomunikacyjnych, przetwarzamy Twoje
        dane transmisyjne, które są niezbędne, aby świadczyć Ci i rozliczyć
        usługi telekomunikacyjne.
      </BlockText>
      <BlockText>Dane transmisyjne przetwarzamy w celu:</BlockText>
      <div className="prose">
        <ol type="a">
          <li>
            wykonania umowy, w tym umożliwić Ci dostęp do naszych usług w
            jakości wynikającej z umowy;
          </li>
          <li>
            naliczania opłat za świadczone usługi oraz w celu i rozpatrywania
            reklamacji;
          </li>
          <li>
            zarządzania ruchem w sieci telekomunikacyjnej oraz rozliczeń z
            innymi operatorami;
          </li>
          <li>
            wykrywania nadużyć i zapobiegania im oraz zapewnienia bezpieczeństwa
            sieci i usług;
          </li>
          <li>ustalenia, obrony i dochodzenia roszczeń;</li>
          <li>
            przechowywania na potrzeby przyszłych postępowań uprawnionych
            organów (przez okres wynikający z przepisów);
          </li>
          <li>marketingu bezpośredniego (o ile udzielisz na to zgody).</li>
        </ol>
      </div>
      <BlockText>
        Danymi transmisyjnymi, które wykorzystujemy, są dane o sposobie
        korzystania z naszych usług telekomunikacyjnych i z naszej sieci. W
        szczególności są to dane:
      </BlockText>
      <div className="prose">
        <ol>
          <li>
            o identyfikatorach urządzenia końcowego (np. telefonu lub tabletu),
            za pomocą którego łączysz się z naszą siecią przewodowo lub
            bezprzewodowo (np. za pomocą karty SIM lub gdy korzystasz z
            połączenia z routerem przez Wi-Fi), oraz o systemie operacyjnym na
            Twoim urządzeniu;
          </li>
          <li>
            o tym, kiedy, jak często i w jaki sposób korzystasz:
            <ol type="a">
              <li>
                z połączeń głosowych i wiadomości tekstowych, w tym o liczbie
                połączeń i wiadomości wychodzących, przychodzących, o ich typie
                (np. krajowe, międzynarodowe, w roamingu), o czasie trwania
                połączeń i o numerach, o technologii połączenia, z którymi się
                komunikujesz;
              </li>
              <li>
                z dostępu do Internetu, w tym o czasie trwania sesji
                internetowych i ilości transferowanych danych, o adresach
                odwiedzanych stron internetowych i Twoich aktywnościach na tych
                stronach, o rodzaju używanej technologii dostępu.
              </li>
            </ol>
          </li>
        </ol>
      </div>
      <BlockText className="mt-5">
        Szczegółowy opis rodzajów danych transmisyjnych, jakie aktualnie
        wykorzystujemy, możesz znaleźć na stronie www.njumobile.pl/mojedane.
        Dane transmisyjne możemy wykorzystywać lub przechowywać przez czas
        trwania umowy, a po jej zakończeniu – w okresie dochodzenia roszczeń lub
        wykonywania innych zadań wynikających z przepisów prawa.
      </BlockText>
      <BlockText className="mt-5">
        W celach wykrywania nadużyć i zapobiegania im, zapewnienia
        bezpieczeństwa sieci i usług oraz – w razie udzielenia nam zgody – w
        celach marketingowych będziemy wykorzystywać dane transmisyjne do
        profilowania naszych klientów, oceniając na przykład, czy ich zachowania
        mogą zagrażać integralności naszej sieci.
      </BlockText>
      <BlockText className="mt-5">
        Przez dane o lokalizacji rozumiemy dane, które pochodzą z sieci
        telekomunikacyjnej i wskazują położenie Twoich urządzeń końcowych.
      </BlockText>
      <BlockText>Przetwarzamy je po to, by:</BlockText>
      <div className="prose">
        <ol type="a">
          <li>wykonać obowiązki wynikające z przepisów prawa;</li>
          <li>
            przygotować lub skierować do Ciebie ofertę (marketing bezpośredni) -
            o ile udzielisz nam na to zgody). Obejmuje to również profilowanie,
            czyli dostosowanie otrzymywanej oferty do miejsc, w których
            korzystasz z naszych usług;
          </li>
          <li>
            świadczyć usługi dodatkowe, gdy dane te są niezbędne do ich
            świadczenia (o ile udzielisz na to zgody).{" "}
          </li>
        </ol>
      </div>
      <BlockText className="mt-5">
        Dane o Twojej lokalizacji będziemy przetwarzać również, gdy wykonasz
        połączenie z numerem alarmowym. Dane te przekażemy Prezesowi UKE
        prowadzącemu system teleinformatyczny służący do gromadzenia i
        udostępniania danych centrom pomocy ratunkowej i służbom powołanym do
        niesienia pomocy.
      </BlockText>
      <BlockText className="mt-5">
        Dane transmisyjne i o lokalizacji po ich całkowitej anonimizacji (to
        znaczy bez informacji, do którego abonenta się odnoszą) możemy
        przetwarzać na potrzeby:
      </BlockText>
      <div className="prose">
        <ul>
          <li>statystyk,</li>
          <li>analiz dotyczących efektywności naszej sieci i jej rozbudowy,</li>
          <li>
            zarządzania ruchem czy badań dotyczących przemieszczania się grup
            ludności między określonymi punktami naszej sieci.
          </li>
        </ul>
      </div>
      <BlockText className="mt-5" weight="bold">
        7. Spisy abonentów i informacja o numerach telefonicznych
      </BlockText>
      <BlockText>
        Jeśli udzielisz na to zgody, możemy umieścić Twoje dane w spisie
        abonentów, a informację o przydzielonych Tobie numerach telefonów - w
        ramach usługi informacji o numerach telefonicznych, jeśli będzie je
        świadczyć. Celem spisu abonentów i informacji o numerach telefonicznych
        jest umożliwienie sprawnego wyszukania numerów telefonów zarówno naszych
        abonentów, jak i abonentów innych operatorów telekomunikacyjnych, którzy
        w tym celu udostępnili ich dane. W spisie można wyszukiwać osoby
        fizyczne (przy użyciu łącznie trzech kryteriów wyszukiwania: nazwiska,
        imienia i miejscowości) oraz firmy czy instytucje (przy użyciu jednego z
        kryteriów: nazwy firmy, ulicy, miasta, powiatu, gminy, województwa,
        telefonu). Usługa informacji o numerach telefonów jest świadczona
        telefonicznie.
      </BlockText>
      <BlockText className="mt-5" weight="bold">
        8. Jakie przysługują Ci uprawnienia
      </BlockText>
      <BlockText>Możesz złożyć do nas wniosek:</BlockText>
      <div className="prose">
        <ol type="a">
          <li>o sprostowanie (poprawienie) Twoich danych;</li>
          <li>
            o usunięcie danych przetwarzanych bezpodstawnie lub umieszczonych na
            naszych serwisach internetowych;
          </li>
          <li>
            o ograniczenie przetwarzania (wstrzymanie operacji na danych lub
            nieusuwanie danych – stosownie do złożonego wniosku);
          </li>
          <li>
            o dostęp do danych (o informację o przetwarzanych przez nas danych
            oraz o kopię danych);
          </li>
          <li>
            o przeniesienie danych do innego administratora danych lub do Ciebie
            (w zakresie określonym w art. 20 RODO).
          </li>
        </ol>
      </div>
      <BlockText>
        Żeby skorzystać z tych praw, złóż wniosek poprzez czat na koncie
        klienta. Możesz też kontaktować się z nami poprzez adresy podane w
        sekcji „Jak możesz się z nami skontaktować” poniżej.
      </BlockText>
      <BlockText>
        Aby mieć pewność, że jesteś uprawniony do złożenia wniosku, możemy
        prosić o podanie dodatkowych informacji pozwalających nam Cię
        uwierzytelnić.
      </BlockText>
      <BlockText>
        Zakres każdego z tych praw oraz sytuacje, w których można z nich
        skorzystać, wynikają z przepisów prawa. To, z którego uprawnienia możesz
        skorzystać, zależeć będzie np. od podstawy prawnej wykorzystywania przez
        nas Twoich danych oraz od celu ich przetwarzania.
      </BlockText>
      <BlockText className="mt-5" weight="bold">
        9. Na czym polega prawo sprzeciwu
      </BlockText>
      <BlockText>
        Niezależnie od praw wymienionych wyżej, możesz w dowolnym momencie
        wnieść sprzeciw wobec przetwarzania Twoich danych (w tym profilowania)
        na potrzeby marketingu bezpośredniego. Po przyjęciu wniosku w tej
        sprawie jesteśmy zobowiązani do zaprzestania przetwarzania danych w tym
        celu.
      </BlockText>
      <BlockText>
        W szczególnych sytuacjach możesz w dowolnym momencie wnieść sprzeciw
        wobec przetwarzania przez nas Twoich danych osobowych (w tym
        profilowania), jeśli podstawą wykorzystania danych jest nasz prawnie
        uzasadniony interes lub interes publiczny. W takiej sytuacji, po
        rozpatrzeniu Twojego wniosku, nie będziemy już mogli przetwarzać danych
        osobowych objętych sprzeciwem na tej podstawie, chyba że wykażemy, iż
        istnieją:
      </BlockText>
      <div className="prose">
        <ol type="a">
          <li>
            ważne prawnie uzasadnione podstawy do przetwarzania danych, które
            według prawa uznaje się za nadrzędne wobec Twoich interesów, praw i
            wolności lub
          </li>
          <li>podstawy do ustalenia, dochodzenia lub obrony roszczeń.</li>
        </ol>
      </div>
      <BlockText className="mt-5" weight="bold">
        10. Kiedy prosimy Cię o zgodę
      </BlockText>
      <BlockText>
        Jeżeli wykorzystanie przez nas Twoich danych nie jest konieczne do
        wykonania umowy, realizacji obowiązku prawnego lub nie stanowi naszego
        prawnie uzasadnionego interesu, możemy prosić o wyrażenie zgody na
        określone sposoby wykorzystania Twoich danych. Taka zgoda może
        umożliwiać np. udostępnienie danych innym podmiotom na potrzeby ich
        akcji promocyjnych lub automatyczne podjęcie decyzji w oparciu o Twoje
        dane i na Twoje żądanie. Udzieloną nam zgodę możesz w każdej chwili
        wycofać w Aplikacji (nie będzie to wpływać na zgodność z prawem
        wykorzystania Twoich danych przed cofnięciem takiej zgody).
      </BlockText>
      <BlockText className="mt-5" weight="bold">
        11. Gdzie możesz złożyć skargę
      </BlockText>
      <BlockText>
        Masz prawo wnieść skargę do Prezesa Urzędu Ochrony Danych Osobowych,
        jeżeli uważasz, że przetwarzamy Twoje dane osobowe niezgodnie z
        przepisami prawa.
      </BlockText>
      <BlockText className="mt-5" weight="bold">
        Informacje uzyskane z Twojego urządzenia
      </BlockText>
      <BlockText weight="bold">
        12. Co przechowujemy w pamięci Twojego urządzenia
      </BlockText>
      <div className="prose">
        <ol type="a">
          <li>
            W naszej Aplikacji korzystamy z rozwiązania umożliwiającego
            przechowywanie w pamięci Twojego urządzenia mobilnego (telefonu,
            tabletu) określonych informacji, które ułatwią Ci korzystanie z
            Aplikacji lub naszych usług („Local Storage”). Local Storage
            wykorzystujemy m.in. po to, by:
            <ul>
              <li>umożliwić zaszyfrowane połączenie z naszą usługą,</li>
              <li>
                przechować na Twoim urządzeniu:
                <ul>
                  <li>
                    podane przez Ciebie dane do zalogowania się w Aplikacji,
                  </li>
                  <li>Twoje ustawienia w Aplikacji;</li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            Przechowywanie informacji w Twoim urządzeniu poprzez rozwiązanie
            Local Storage ani uzyskiwanie przez nas do nich dostępu nie powoduje
            zmian konfiguracyjnych w Twoim urządzeniu ani w zainstalowanym na
            nim oprogramowaniu;
          </li>
          <li>
            W każdej chwili możesz usunąć informacje przechowywane dzięki
            rozwiązaniu Local Storage na Twoim urządzeniu poprzez odinstalowanie
            Aplikacji oraz, w zależności od Twojego systemu operacyjnego,
            poprzez skasowanie w ustawieniach urządzenia mobilnego informacji z
            pamięci (cache) Aplikacji lub wylogowanie się z Aplikacji;
          </li>
          <li>
            W związku z tym, że Aplikacja pozostanie aktywna aż do momentu, gdy
            się z niej nie wylogujesz, zadbaj, aby niepożądane osoby nie
            uzyskały dostępu do Twojego urządzenia mobilnego, na którym
            zalogowałeś się do Aplikacji.
          </li>
        </ol>
      </div>
      <BlockText className="mt-5" weight="bold">
        13. Jak korzystamy z narzędzi innych podmiotów
      </BlockText>
      <div className="prose">
        <ol type="a">
          <li>
            W Aplikacji wykorzystujemy narzędzia innych podmiotów. Dostawcy tych
            narzędzi mogą umieszczać pliki cookies lub tokeny w Twoim urządzeniu
            lub uzyskiwać dostęp do informacji, które są przechowywane na Twoim
            urządzenia. Dotyczy to dostawców:
            <ul>
              <li>
                serwisów społecznościowych Facebook lub Google (dalej „serwisy
                społecznościowe”) - w celu umożliwienia zalogowania się do
                Aplikacji poprzez te serwisy. W takiej sytuacji uzyskamy od
                serwisów społecznościowych informację o Twoim adresie e-mail,
                który będziemy wykorzystywać do kontaktu z Tobą w związku z
                działaniem Aplikacji. W związku z obecnością przycisku do
                logowania w Aplikacji (czyli z tym, że Aplikacja wywołuje
                wyświetlenie przycisku, kontaktując się z serwerem dostawcy
                serwisu społecznościowego), dostawca serwisu może wejść w
                posiadanie informacji o tym, z jakiej Aplikacji, z jakiego
                urządzenia oraz przez jakie połączenie doszło do wyświetlenia
                przycisku. Zakres zbieranych informacji oraz zasady korzystania
                z nich określa polityka prywatności danego dostawcy serwisu
                społecznościowego;
              </li>
              <li>
                narzędzia statystycznego Firebase lub Google Analytics
                (dostarczanych przez Google Ireland Limited). Będziemy zbierać
                unikatowy identyfikator instancji Aplikacji oraz ogólne
                informacje o tym jak z niej korzystasz. Użyjemy tych informacji
                po to, by ulepszać funkcjonalności Aplikacji i jej zawartość;
              </li>
              <li>
                narzędzia Google Signals (dostarczanego przez Google Ireland
                Limited) Dzięki Google Signals możemy powiązać w Google
                Analytics informacje o wizytach w naszej aplikacji z
                informacjami o Tobie, które Google otrzymuje gdy korzystasz z
                konta Google na różnych urządzeniach. Aby to powiązanie było
                możliwe, musisz wcześniej włączyć usługę personalizacji reklam
                Google. Informacje, jakie Google przekaże do Google Signals,
                mogą być oparte o Twoją lokalizację, historię korzystania z
                usług Google i o dane z witryn innych partnerów Google. Dane
                zbierane przez Google Signals wykorzystywane są do tworzenia
                zbiorczych, anonimowych statystyk i raportów dotyczących
                zachowania użytkowników na różnych urządzeniach. Dane, jakie
                widzimy w Google Signals, są przetworzone przez Google w taki
                sposób nie umożliwiają nam określenia tożsamości osoby, której
                dana porcja danych dotyczy. Informacje o tym, jak Twoje dane są
                przetwarzane przez Google, znajdziesz na stronie:{" "}
                <Link
                  className="underline"
                  href="https://business.safety.google/privacy/"
                  rel="noreferrer"
                  target="_blank"
                >
                  https://business.safety.google/privacy/
                </Link>
                oraz na stronie:{" "}
                <Link
                  className="underline"
                  href="https://policies.google.com/technologies/partner-sites?hl=pl"
                  rel="noreferrer"
                  target="_blank"
                >
                  https://policies.google.com/technologies/partner-sites?hl=pl
                </Link>
              </li>
              <li>
                narzędzia One Signal (świadczonego przez OneSignal Inc. z
                siedzibą w USA) w celu umożliwienia wysyłania komunikatów PUSH w
                Aplikacji. Abyśmy mogli przesyłać komunikaty PUSH i uwzględnić
                przy tym sposób, w jaki korzystasz z Aplikacji, narzędzie to
                zbiera m.in. informacje:
                <ul>
                  <li>o tym, jak korzystasz z Aplikacji,</li>
                  <li>o modelu i systemie operacyjnym Twojego urządzenia,</li>
                  <li>o ustawieniach i Aplikacjach, jakich używasz,</li>
                  <li>o komunikatach PUSH, które wysłaliśmy,</li>
                  <li>o identyfikatorach reklamowych urządzenia,</li>
                  <li>o sieci komórkowej wykorzystujesz,</li>
                  <li>o adresie IP połączenia.</li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            W ustawieniach Twojego konta w serwisie społecznościowym jego
            dostawca może informować o tym, że korzystasz z logowania do naszej
            Aplikacji z użyciem jego serwisu. Na warunkach określonych przez ten
            serwis społecznościowy, możesz również zablokować możliwość
            logowania do naszej Aplikacji za pomocą tego serwisu.
          </li>
          <li>
            Informacje o tym, na jakich zasadach usługa Google Analytics zbiera
            i przetwarza dane, udostępnia jej dostawca na stronie
            www.google.com/intl/pl/policies/privacy/partners/ lub pod innym
            adresem URL, który Google może udostępnić publicznie w dowolnym
            czasie. Strona ta wskazuje także, w jaki sposób możesz kontrolować
            informacje gromadzone przez Google w związku z tym, że korzystasz z
            Aplikacji.
          </li>
          <li>
            Informacje o tym, na jakich zasadach usługa One Signal zbiera i
            przetwarza dane, udostępnia jej dostawca na stronie{" "}
            <Link
              className="underline"
              href="https://onesignal.com/privacy_policy"
              rel="noreferrer"
              target="_blank"
            >
              https://onesignal.com/privacy_policy
            </Link>
            . Strona ta wskazuje również, w jaki sposób możesz ograniczyć to,
            jak wykorzystamy informacje, które pobraliśmy z urządzenia.
          </li>
          <li>
            Możesz w każdej chwili wycofać zgodę na użycie narzędzi ww.
            dostawców poprzez zmianę ustawień w systemie operacyjnym Twojego
            urządzenia oraz użycie rozwiązań blokujących te narzędzia
            udostępnionych przez dostawców albo poprzez odinstalowanie Aplikacji
            z Twojego urządzenia.
          </li>
          <li>
            Komunikaty PUSH możesz w każdej chwili wyłączyć w ustawieniach:
            <ul>
              <li>Aplikacji lub</li>
              <li>systemu operacyjnego Twojego urządzenia.</li>
            </ul>
          </li>
        </ol>
      </div>
      <BlockText className="mt-5" weight="bold">
        14. Do jakich funkcjonalności Twojego urządzenia uzyskujemy dostęp
      </BlockText>
      <BlockText>
        Nasza Aplikacja uzyskuje dostęp między innymi do następujących
        funkcjonalności Twojego urządzenia:
      </BlockText>
      <div className="prose">
        <ul>
          <li>
            aparatu – aby dać Ci możliwość, by:
            <ul>
              <li>skanować QR kody,</li>
              <li>zrobić zdjęcie „selfie” czy zdjęcia dokumentu tożsamości;</li>
            </ul>
          </li>
          <li>
            funkcjonalności związanych z lokalizacją (w tym np. GPS - w
            zależności od systemu operacyjnego Twojego urządzenia mobilnego) –
            abyśmy mogli tworzyć statystyki dotyczące naszych użytkowników;
          </li>
          <li>
            czytnika linii papilarnych lub funkcjonalności rozpoznawania twarzy
            – aby umożliwić Ci logowanie się do naszej Aplikacji poprzez odcisk
            palca lub rozpoznanie twarzy.
          </li>
        </ul>
      </div>
      <BlockText>
        W przypadku tych funkcjonalności system operacyjny Twojego telefonu
        przechowuje Twój odcisk palca i zdjęcie Twojej twarzy - nie są one
        przesyłane do naszych systemów. Gdy logujesz się do Aplikacji, dostajemy
        tylko informację (z systemu operacyjnego Twojego telefonu), czy udało Ci
        się zalogować się z użyciem wybranej funkcjonalności, czy nie.
      </BlockText>
      <BlockText className="mt-5" weight="bold">
        Inne informacje – pliki cookies
      </BlockText>
      <BlockText weight="bold">15. Czym są pliki cookies</BlockText>
      <BlockText>
        Na naszej stronie wykorzystujemy pliki cookies, które mogą nie być
        powiązane z Twoimi danymi osobowymi. W plikach tych możemy zapisać
        informację o tym, z jakich części Serwisu lub z jakich innych stron
        internetowych korzystasz. O tym, czy je przyjmujesz i które z nich
        wybierasz, możesz decydować poprzez cookie baner w Serwisie lub poprzez
        ustawienia Twojej przeglądarki. Jeśli chcesz dowiedzieć więcej o tym,
        czym są pliki cookies i jak możesz nimi zarządzać, zapraszamy na stronę
        www.njumobile.pl/cookies.
      </BlockText>
      <BlockText className="mt-5" weight="bold">
        16. Do czego wykorzystujemy pliki cookies
      </BlockText>
      <BlockText>Wykorzystujemy pliki cookies, aby:</BlockText>
      <div className="prose">
        <ol type="a">
          <li>
            utrzymać ciągłość Twojej sesji po zalogowaniu w Serwisie (niezbędne
            cookie). Dzięki temu w ramach jednej sesji nie musisz ponownie
            wpisywać danych do zalogowania na każdej podstronie naszej strony;
          </li>
          <li>zapewnić bezpieczeństwo sesji (niezbędne cookie);</li>
          <li>skorzystać z opcji „Zapamiętaj mnie” (cookie funkcjonalne);</li>
          <li>zapamiętać Twoje ustawienia w Serwisie (cookie funkcjonalne);</li>
          <li>
            dostosować stronę i reklamy, które wyświetlamy, do Twoich potrzeb
            (cookie personalizacyjne);
          </li>
          <li>
            tworzyć statystyki podstron i funkcjonalności Serwisu, z których
            korzystają użytkownicy (cookie analityczne);
          </li>
          <li>
            dopasowywać reklamy, które możesz zobaczyć na innych stronach
            internetowych lub w innybanerch Aplikacjach mobilnych (cookie
            marketingowe). W tym celu możemy wykorzystywać informacje, które
            pochodzą z plików cookies umieszczonych w Twoim urządzeniu na innych
            stronach internetowych. Możemy też – w granicach, które dopuszcza
            prawo lub zgody, jakich udzielisz – skorzystać:
            <ul>
              <li>z informacji od dostawców zewnętrznych baz danych,</li>
              <li>
                z Twoich danych, jakie zgromadziliśmy na podstawie umów, jakie
                nas z Tobą łączą.
              </li>
            </ul>
          </li>
        </ol>
      </div>
      <BlockText className="mt-5" weight="bold">
        17. Do czego służy opcja „Zapamiętaj mnie”
      </BlockText>
      <BlockText>
        Dzięki opcji „Zapamiętaj mnie” nie musisz za każdym razem logować się do
        Serwisu, żeby uzyskać dostęp do swojego konta. Jeśli wybierzesz tę opcję
        na danym urządzeniu, będzie ona na nim działać, aż ją wyłączysz. Zwróć
        uwagę, że jeśli wybierzesz opcję „Zapamiętaj mnie”, każda osoba, która
        będzie korzystać z Twojego urządzenia, może uzyskać dostęp do Twojego
        konta w Serwisie. W ramach takiego dostępu osoba może też otrzymać pewne
        wiadomości o Twojej umowie o świadczenie usług telekomunikacyjnych.
      </BlockText>
      <BlockText className="mt-5" weight="bold">
        18. Co stanie się, gdy wylogujesz się z Serwisu
      </BlockText>
      <BlockText>
        Jeśli wylogujesz się z Serwisu, nie uzyskasz dostępu do konta w
        Serwisie, dopóki nie zalogujesz się ponownie. Mimo to nadal możemy umieć
        Ciebie rozpoznać jako naszego klienta (w oparciu o sieć i urządzenia, z
        których korzystasz, czy pliki cookie, które przesyła Twoja
        przeglądarka).
      </BlockText>
      <BlockText className="mt-5" weight="bold">
        19. Czym są zewnętrzne pliki cookies
      </BlockText>
      <BlockText>
        To pliki cookies, które umieszcza w Twojej przeglądarce podmiot, z
        którym współpracujemy. Zależnie od formy współpracy, może je wykorzystać
        w celach ustalonych z nami, lub także w celach własnych.
      </BlockText>
      <BlockText className="mt-5" weight="bold">
        20. Do czego służą skrypty partnerów.
      </BlockText>
      <BlockText>
        Niektóre strony w naszym Serwisie mogą wykorzystywać kody (np.
        JavaScript), które pochodzą od podmiotów, które z nami współpracują (np.
        producentów sprzętu elektronicznego). Dzięki nim firmy te umieszczają
        swoje pliki cookies w Twojej przeglądarce i dopasowują do Twoich
        preferencji reklamy, które prezentują na innych stronach internetowych.
      </BlockText>
      <BlockText>
        Gdy będziesz korzystać z Serwisu, niektóre podmioty zewnętrzne mogą
        umieścić pliki cookies w Twoim urządzeniu (tzw. pliki cookies
        zewnętrzne). Podmiotami tymi będą w szczególności dostawcy takich
        serwisów jak:
      </BlockText>
      <div className="prose">
        <ul>
          <li>Facebook,</li>
          <li>Twitter,</li>
          <li>Google,</li>
          <li>YouTube,</li>
          <li>DailyMotion.</li>
        </ul>
      </div>
      <BlockText>
        Dzięki tym plikom możesz korzystać z funkcjonalności naszego Serwisu,
        które są zintegrowane z tymi serwisami. Pliki związane z tzw. pikselem
        Facebook posłużą do tego, by skierować do Ciebie naszą profilowaną
        reklamę w serwisie Facebook. Będzie ona oparta o informacje o tym, jakie
        strony w naszym Serwisie najchętniej odwiedzasz. W Serwisie korzystamy z
        narzędzi firmy RTB House (RTB House S.A., ul. Złota 61/101, 00-819
        Warszawa). Pozwalają one RTB House oraz podmiotom, z którymi
        współpracuje, rozpoznać na innych stronach internetowych użytkownika,
        który odwiedził nasz Serwis, i wyświetlić mu reklamy w oparciu o to, co
        oglądał w naszym Serwisie. Jeśli nie chcesz, aby RTB House wyświetało
        reklamy w oparciu o Twoją aktywność w internecie możesz wypisać się na
        jeden z dwóch sposobów:
      </BlockText>
      <div className="prose">
        <ul>
          <li>
            wybrać w reklamie prezentowanej we współpracy z RTB House przycisk
            „=” w lewym dolnym rogu, i zaznaczyć opcję „optout”, lub{" "}
          </li>
          <li>
            wybrać tę opcję bezpośrednio na stronie
            https://optout.rtbhouse.com/.
          </li>
        </ul>
      </div>
      <BlockText>
        Więcej informacji, jak Twoje dane mogą być przetwarzane w narzędziach
        RTB House znajdziesz w polityce prywatności dla usług pod adresem
        https://www.rtbhouse.com/privacy-center. Nasz Serwis wykorzystuje także
        skrypty Microsoft Advertising. Pozwalają one firmie Microsoft rozpoznać
        użytkowników, którzy korzystali z usług Microsoft i odwiedzają naszą
        stronę. W tym celu Microsoft może także przetwarzać dane osobowe
        użytkowników swoich usług. Dzięki skryptom, które umieszczamy, razem z
        firmą Microsoft możemy badać skuteczność naszych reklam w usługach
        Microsoft, w tym w wyszukiwarce Bing. O tym, jak Microsoft przetwarza
        dane swoich użytkowników, możesz przeczytać w Oświadczeniu o ochronie
        prywatności w firmie Microsoft
        (https://privacy.microsoft.com/pl-pl/privacystatement).. Każdy z
        dostawców określa zasady korzystania z plików cookies w swojej polityce
        prywatności. Podmioty te mogą wykorzystywać pliki cookie, sygnały
        nawigacyjne i podobne technologie, aby gromadzić lub odbierać informacje
        z Serwisu i innych miejsc w internecie, a potem użyć ich do usług, które
        świadczą (np. mierzenie ruchu w internecie i wyświetlanie reklam).
        Istnieją rozwiązania, dzięki którym możesz decydować, w jakim zakresie
        chcesz, aby informacje o Tobie były gromadzone i używane do kierowania
        Strona 6 z 7 reklam w internecie. Rozwiązania te znajdziesz m.in. na
        stronach:
      </BlockText>
      <div className="prose">
        <ul>
          <li>
            <Link
              className="underline"
              href="http://www.aboutads.info/choices"
              rel="noreferrer"
              target="_blank"
            >
              http://www.aboutads.info/choices
            </Link>
            ,
          </li>
          <li>
            <Link
              className="underline"
              href="http://www.youronlinechoices.eu/"
              rel="noreferrer"
              target="_blank"
            >
              http://www.youronlinechoices.eu/
            </Link>
            .
          </li>
        </ul>
      </div>
      <BlockText className="mt-5" weight="bold">
        21. Jak badamy korzystanie ze strony
      </BlockText>
      <BlockText>
        Podmioty takie jak Google Inc. oraz Comscore mogą wykorzystać pliki
        cookies zewnętrzne aby zbierać informacje o tym, jak użytkownicy strony
        korzystają z Serwisu. Informacje te służą, aby opracować statystyki i
        poprawić działanie Serwisu. Informacje o tym, jak Google w narzędziu
        Google Analytics używa danych z witryn i Aplikacji, które korzystają z
        ich usług, znajdziesz na stronie{" "}
        <Link
          className="underline"
          href="https://www.google.com/policies/privacy/partners/"
          rel="noreferrer"
          target="_blank"
        >
          https://www.google.com/policies/privacy/partners/
        </Link>
        . Możesz pobrać dodatek do przeglądarki, który ograniczy zakres
        informacji, jakie wykorzystuje Google Analytics. Znajdziesz go na
        stronie{" "}
        <Link
          className="underline"
          href="https://tools.google.com/dlpage/gaoptout?hl=pl"
          rel="noreferrer"
          target="_blank"
        >
          https://tools.google.com/dlpage/gaoptout?hl=pl
        </Link>
        .
      </BlockText>
      <BlockText className="mt-5" weight="bold">
        22. Jak cofniesz zgodę na pliki cookies
      </BlockText>
      <BlockText>
        Poprzez odpowiednie ustawienia przeglądarki na Urządzeniu możesz wyrazić
        zgodę na przechowywanie i uzyskiwanie dostępu do plików cookies
        (umożliwiając przyjmowanie plików cookies) lub taką zgodę cofnąć
        (blokując przyjmowanie plików cookies). W każdej chwili możesz także
        usunąć umieszczone pliki cookies za pomocą opcji dostępnych w
        przeglądarce internetowej lub w systemie operacyjnym Twojego urządzenia.
        Informujemy jednak, że usunięcie, zablokowanie lub ograniczenie
        umieszczania plików cookies może spowodować utrudnienia korzystania z
        Serwisu, a nawet uniemożliwić korzystanie z niektórych jego opcji.
      </BlockText>
      <BlockText className="mt-5" weight="bold">
        23. Jak możesz się z nami skontaktować
      </BlockText>
      <BlockText>
        We wszystkich sprawach dotyczących Twoich danych osobowych kontaktuj się
        z nami poprzez czat w Aplikacji lub stronę nju.pl Jeśli potrzebujesz
        złożyć wniosek na piśmie, możesz napisać do nas na adres: Orange Polska
        S.A.,
      </BlockText>
      <BlockText>ul. Jagiellońska 34, 96-100 Skierniewice</BlockText>
      <BlockText>
        Dane kontaktowe Inspektora Ochrony Danych w Orange Polska S.A:
      </BlockText>
      <BlockText>inspektorochronydanych@orange.com</BlockText>
      <BlockText className="mt-5" weight="bold">
        24. Gdzie znajdziesz więcej informacji
      </BlockText>
      <BlockText>Szczegóły na temat tego:</BlockText>
      <div className="prose">
        <ul>
          <li>jak wykorzystujemy i zabezpieczamy Twoje dane osobowe,</li>
          <li>jakie uprawnienia Ci przysługują,</li>
          <li>jak możesz z nich skorzystać,</li>
        </ul>
      </div>
      <BlockText>znajdziesz na stronie www.njumobile.pl/mojedane.</BlockText>
      <BlockText>
        Wersja Polityki prywatności, którą właśnie czytasz, obowiązuje od 15
        stycznia 2025 roku.
      </BlockText>
      <BlockText className="mt-10">Nasze dane rejestrowe:</BlockText>
      <BlockText>
        Orange Polska Spółka Akcyjna z siedzibą i adresem w Warszawie, 02-326
        przy Al. Jerozolimskich 160, wpisana do rejestru przedsiębiorców
        prowadzonego przez Sąd Rejonowy dla m.st. Warszawy, XII Wydział
        Gospodarczy Krajowego Rejestru Sądowego, pod numerem 0000010681; REGON
        012100784, NIP 526-02-50-995; z pokrytym w całości kapitałem zakładowym
        wynoszącym 3 937 072 437 złotych.
      </BlockText>
    </>
  );
}
